import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from '../../../../../shared/components/button/button.component';
import { OrderItem } from '../../order-v2.types';

@Component({
  selector: 'app-adjustments-modal',
  standalone: true,
  imports: [CommonModule, ButtonComponent],
  templateUrl: './adjustments-modal.component.html',
  styleUrl: './adjustments-modal.component.scss',
})
export class AdjustmentsModalComponent {
  @Input({ required: true }) item!: OrderItem | null;
  @Input() open = false;
  @Output() closed = new EventEmitter<void>();

  close(): void {
    this.closed.emit();
  }

  onBackdropClick(event: MouseEvent): void {
    if (event.target === event.currentTarget) this.close();
  }

  @HostListener('document:keydown.escape')
  onEsc(): void {
    if (this.open) this.close();
  }

  formatCents(value: number): string {
    return ((value ?? 0) / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  formatAdjustment(value: number): string {
    const formatted = this.formatCents(value);
    if ((value ?? 0) > 0) return `+${formatted}`;
    return formatted;
  }

  adjustmentTypeLabel(type: string): string {
    switch (type) {
      case 'Coupon': return 'cupom';
      case 'ManualPrice': return 'preço manual';
      default: return 'promoção';
    }
  }

  totalAdjustments(): number {
    return (this.item?.adjustments ?? []).reduce((sum, a) => sum + a.value, 0);
  }

  adjClass(value: number): string[] {
    if (value < 0) return ['text-emerald-500', 'dark:text-emerald-400'];
    if (value > 0) return ['text-rose-500', 'dark:text-rose-400'];
    return ['text-neutral-500', 'dark:text-neutral-400'];
  }
}
